import React from "react"
import DescriptionPanel from "./DescriptionPanel"
import TitlePanel from "./TitlePanel"

const ServiceStructure = props => {
  return (
    <div>
      <TitlePanel
        url={props.url}
        serviceType={props.serviceType}
        department={props.department}
      />
      <br></br>
      <DescriptionPanel detailsType={props.detailsType} />
    </div>
  )
}

export default ServiceStructure
